import type { SvgComponent } from '@/types/SvgComponent';

export const PlayFilledIcon: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <g clipPath="url(#clip0_822_583)">
        <path
          d="M5.27734 3.21802C5.45049 3.22168 5.62082 3.26006 5.77832 3.32935L5.93066 3.40845L5.93262 3.40942L19.4375 11.6692C19.6282 11.7846 19.7861 11.9477 19.8955 12.1418C20.0049 12.3359 20.0624 12.5548 20.0625 12.7776C20.0625 13.0005 20.0049 13.2202 19.8955 13.4143C19.7865 13.6076 19.629 13.7688 19.4395 13.884L5.93262 22.1458L5.93066 22.1467C5.7334 22.2665 5.50804 22.3323 5.27734 22.3372C5.04685 22.342 4.81917 22.2862 4.61719 22.175C4.46562 22.0916 4.33197 21.9792 4.22461 21.845L4.12598 21.7034C4.00679 21.5058 3.94178 21.2798 3.9375 21.0491V4.5061L3.95215 4.33423C3.97784 4.16446 4.03674 4.00077 4.12598 3.85278C4.24522 3.65523 4.41505 3.4924 4.61719 3.3811C4.81921 3.26991 5.04679 3.21319 5.27734 3.21802Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_822_583">
          <rect width="24" height="24" fill="white" transform="translate(0 0.777832)" />
        </clipPath>
      </defs>
    </svg>
  );
};
